import type {GridDensity} from "@mui/x-data-grid";


export interface CategorizationTableSettings {
    density?: GridDensity;
}

export const CATEGORIZATION_TABLE_DENSITY_OPTIONS: {label: string; value: GridDensity}[] = [
    // Disabled for now
    // {label: 'Compact density', value: 'compact'},
    // {label: 'Standard density', value: 'standard'},
    // {label: 'Comfortable density', value: 'comfortable'},
];

const DEFAULT_SETTINGS: CategorizationTableSettings = {
    density: 'standard',
}

const SETTINGS_STORAGE_KEY = 'categorization-table-settings'
export const getCategorizationTableInitialSettings = (): CategorizationTableSettings => {
    try {
        const storedSettings = localStorage.getItem(SETTINGS_STORAGE_KEY);
        return storedSettings ? JSON.parse(storedSettings) : DEFAULT_SETTINGS;
    } catch {
        return DEFAULT_SETTINGS;
    }
};

export const storeCategorizationTableSettings = (settings: CategorizationTableSettings) => {
    localStorage.setItem(SETTINGS_STORAGE_KEY, JSON.stringify(settings));
}

export const devopsClearCategorizationTableSettings = () => {
    localStorage.removeItem(SETTINGS_STORAGE_KEY)
}
